import { ErrorList, TableStyle, TableTitle } from '../../../style';
import { tableSectionsAIF001 } from '../../../consts/tableSections';
import { IoIosArrowUp } from 'react-icons/io';
import React from 'react';
import { idCreator } from '../../../../../Project/utils/idCreator';

export const AIF001Reports = ({
  isStaticTemplate,
  targetRef,
  funds,
  currentDataKey,
  onChangeFund,
  schema,
  addRow,
  onDeleteRow,
  isMultiFunds,
  sectionRefs
}) => {
  const tableProps = {
    currentDataKey,
    funds,
    onChangeFund,
    schema,
    isStaticTemplate,
    isMultiFunds
  };

  return (
    <div
      className="tables k-grid"
      id={isStaticTemplate ? 'static-table' : 'pdfContainer'}
      ref={targetRef}
      style={{
        height: '100%'
      }}
    >
      {funds[currentDataKey]?.report_status?.errors?.length > 0 && (
        <ErrorList id="fca-aif001-report-status-errors">
          <IoIosArrowUp id="fca-aif001-report-status-toggle" />
          <div className="body" id="fca-aif001-report-status-body">
            <div className="header" id="fca-aif001-report-status-header">
              <p className="title" id="fca-aif001-report-status-title">
                Submission status:
              </p>
              <p
                className="status"
                id="fca-aif001-report-status-badge"
                style={{ background: '#DF4141' }}
              >
                Not submitted
              </p>
            </div>
            <ul id="fca-aif001-report-status-list">
              {funds?.[currentDataKey]?.report_status?.errors?.map(item => (
                <li
                  key={item.reference_key}
                  id={`fca-aif001-report-status-error-${idCreator(item.reference_key)}`}
                >
                  <span
                    className="underline"
                    id={`fca-aif001-report-status-reference-${idCreator(item.reference_key)}`}
                  >
                    Reference: {item.reference_key}
                  </span>
                  , Error message:{' '}
                  <i id={`fca-aif001-report-status-message-${idCreator(item.reference_key)}`}>
                    {item.error_message}
                  </i>
                </li>
              ))}
            </ul>
          </div>
        </ErrorList>
      )}

      {tableSectionsAIF001.map(({ key, title, Component, hasAddDelete }) => (
        <React.Fragment key={key}>
          {title && (
            <TableTitle id={key} ref={el => (sectionRefs.current[key] = el)}>
              {title}
            </TableTitle>
          )}
          <TableStyle id={`fca-aif001-table-section-${key}`}>
            <Component
              {...tableProps}
              onAddColumn={hasAddDelete ? addRow : undefined}
              onDeleteColumn={hasAddDelete ? onDeleteRow : undefined}
            />
          </TableStyle>
        </React.Fragment>
      ))}
    </div>
  );
};
